import { handleTouchEvents } from '../../utilities/touchEvent'

document.addEventListener('DOMContentLoaded', () => {
  handleTouchEvents('[data-mp-block-layout="carousel-photocard"] .block__main')
})
